var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_163_139428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.660492 15.4696C-0.220163 13.941 -0.220164 12.059 0.660492 10.5304L5.29982 2.47756C6.18294 0.944662 7.81739 9.32214e-08 9.58648 1.14318e-07L18.8467 2.24745e-07C20.6158 2.45841e-07 22.2503 0.944662 23.1334 2.47756L27.7727 10.5304C28.6534 12.059 28.6534 13.941 27.7727 15.4696L23.1334 23.5224C22.2503 25.0553 20.6158 26 18.8467 26L9.58648 26C7.81739 26 6.18294 25.0553 5.29982 23.5224L0.660492 15.4696Z",
    fill: "url(#paint0_linear_163_139428)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4553 12.0593C17.2499 11.3348 18.3103 10.3681 18.5045 8.16315C18.5224 7.95939 18.6895 7.79708 18.8941 7.79708H18.9057C19.11 7.79708 19.2757 7.63144 19.2757 7.42711C19.2757 7.22277 19.11 7.05713 18.9057 7.05713H10.0262C9.82189 7.05713 9.65625 7.22277 9.65625 7.42711C9.65625 7.63144 9.82189 7.79708 10.0262 7.79708H10.0379C10.2424 7.79708 10.4095 7.95939 10.4274 8.16316C10.6217 10.3681 11.682 11.3348 12.4766 12.0593C13.0382 12.5714 13.356 12.8848 13.356 13.3714C13.356 13.858 13.0382 14.1715 12.4766 14.6835C11.682 15.408 10.6217 16.3748 10.4274 18.5797C10.4095 18.7834 10.2424 18.9457 10.0379 18.9457H10.0262C9.82189 18.9457 9.65625 19.1114 9.65625 19.3157C9.65625 19.5201 9.82189 19.6857 10.0262 19.6857H18.9057C19.11 19.6857 19.2757 19.5201 19.2757 19.3157C19.2757 19.1114 19.11 18.9457 18.9057 18.9457H18.8941C18.6895 18.9457 18.5224 18.7834 18.5045 18.5797C18.3103 16.3748 17.2499 15.408 16.4553 14.6835C15.8937 14.1715 15.5759 13.858 15.5759 13.3714C15.5759 12.8848 15.8937 12.5714 16.4553 12.0593ZM14.096 15.7913C14.096 15.9971 13.9488 16.1695 13.7586 16.2482L12.641 16.7107C12.2105 16.8888 11.8225 16.4786 12.1123 16.1137C12.3908 15.7632 12.6947 15.486 12.9751 15.2304C13.5515 14.7048 14.096 14.2084 14.096 13.3714V15.7913ZM15.9568 15.2304C16.2372 15.486 16.5411 15.7632 16.8195 16.1137C17.1094 16.4786 16.7214 16.8888 16.2908 16.7106L15.1733 16.2482C14.9831 16.1695 14.8359 15.9971 14.8359 15.7913V13.3714C14.8359 14.2084 15.3804 14.7048 15.9568 15.2304ZM11.8426 9.52365C11.6239 9.52365 11.4251 9.38962 11.3634 9.17977C11.2897 8.92922 11.2312 8.65353 11.192 8.34827C11.1537 8.04936 11.3967 7.79708 11.698 7.79708H17.2339C17.5352 7.79708 17.7782 8.04936 17.7399 8.34827C17.7007 8.65353 17.6422 8.92923 17.5685 9.17979C17.5068 9.38963 17.3081 9.52365 17.0893 9.52365H11.8426Z",
    fill: "#E9BE5C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_163_139428",
    x: -2.35461,
    y: -2.35461,
    width: 33.1428,
    height: 30.7092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.17731
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_163_139428"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_163_139428",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.362248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.181124
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_163_139428"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.07911
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_163_139428",
    result: "effect3_innerShadow_163_139428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_139428",
    x1: 1.55023e-7,
    y1: 13,
    x2: 28.4332,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandglass);
export default __webpack_public_path__ + "static/media/sandglass.5f3be264bf5a863d1befb307805b38f6.svg";
export { ForwardRef as ReactComponent };